import Model from './Model'
import Project from './Project'
import HasClientTraits from "./decorators/HasClientTraits";
import HasTalentTraits from "./decorators/HasTalentTraits";
import Auth from "../Auth";
import Interview from "./Interview";
import HasMatching from "./decorators/HasMatching";
import React from "react";
import Discipline from "./Discipline";

let UserStatuses = {
    Unregistered: "Unregistered",
    Applying: "Applying",
    Deactivated: "Deactivated",
    Restricted: "Restricted",
    Disabled: 'Disabled',

    Active: "Active",

    UnderReview: 'Application Under Review',

    ApplicationUnderReview: 'Application Under Review',
    RejectedApplication: "Rejected Application",


    HasDisciplinesPendingApproval: 'Has Disciplines Pending Approval',
    HasDisciplineAppealsPendingApproval: 'Has Discipline Appeals Pending Approval',

    BuildingProfile: 'Building Profile',
    ProfileUnderReview: 'Profile Under Review',
    ProfileRejected: 'Profile Rejected',
    ProfileApproved: "Active",

    HasProfileAppealPendingApproval: 'Has Profile Appeal Pending Approval',

    TalentInvitedByClient: 'Invited by Client',
    // Archived: "Archived",

    //OLD STATUSES
    PendingApproval: "Pending Approval",
    ApprovedPendingAgreement: "Approved Pending Agreement",
    ActiveProfilePending: "Active - Profile Pending",
    ActiveProfileIncomplete: "Active - Incomplete Profile",
}













export default class User extends HasMatching(HasTalentTraits(HasClientTraits(Model)))
{
	static Key = 'User';

	static normalize(props) {
		if (props.phone) {

			// let phoneModel = this.parsePhoneNumber(props.phone);
			// if(phoneModel) {

				// props.phone = phoneModel.join('-');
                // if (!props.phone?.includes('+') && props.phone?.length === 10) {
                //     let phoneModel = this.parsePhoneNumber(props.phone);
                //     props.phone = '+1 ' + phoneModel.join('-')
                // }else if (TB.startsWith(props.phone, '1') && props.phone?.length === 11) {
                //     props.phone = '+' + props.phone
                // }
            // }
		}

		if (!TB.isDefined(props.is_business)) {
            props.is_business = (props.business_name || props.business_type) ? 1 : 0;
        }

		if (props.bio) {
            props.bio = props.bio.replace(/<br\s*[\/]?>/gi, "\n");
        }

        if (props.talent_disciplines) {

            props.talent_disciplines = TB.uniqBy(props.talent_disciplines, 'id');
            if (props.is_auth) {
                let imported = this.getImportedItemsFromResumeForUser(props.id,'talent_disciplines');
                if (imported?.length) {
                    let importedIds = TB.map(imported, item => parseInt(item.id));
                    props.talent_disciplines = TB.orderBy(props.talent_disciplines, dis => importedIds?.includes(dis.id), 'desc');
                }
            }
            // props.talent_disciplines = TB.map(props.talent_disciplines, discipline => {
            //     if (discipline.self_score === 90) {
            //         discipline.self_score = 80;
            //     }
            //     return discipline
            // })
        }
        if (!TB.isDefined(props.can_travel_for_work)) {
            props.can_travel_for_work = props.can_travel_for_work ? 1 : 0;
        }

        if (TB.isDefined(props.min_hourly_rate)) {
            props.min_hourly_rate = Number.parseFloat(props.min_hourly_rate);
        }
        if (TB.isDefined(props.ideal_hourly_rate)) {
            props.ideal_hourly_rate = Number.parseFloat(props.ideal_hourly_rate);
        }

        if (TB.isNaN(props.ethnicity)) props.ethnicity = undefined;
        if (TB.isNaN(props.race)) props.race = undefined;
        if (TB.isNaN(props.gender)) props.gender = undefined;
        if (TB.isNaN(props.preferred_pronoun)) props.preferred_pronoun = undefined;

        if (props.ethnicity && !Object.keys(laravel.talent_questions.ethnicity_options).includes(props.ethnicity)) {
            props.ethnicity_option = props.ethnicity;
            props.ethnicity = 'Other (Please specify)';
        }else if (props.ethnicity !== 'Other (Please specify)' &&
            Object.keys(laravel.talent_questions.ethnicity_options).includes(props.ethnicity)) {
            props.ethnicity_option = undefined;
        }

        if (props.race && !Object.keys(laravel.talent_questions.race_options).includes(props.race)) {
            props.race_option = props.race;
            props.race = 'Other (Please specify)';
        }else if (props.race !== 'Other (Please specify)' &&
            Object.keys(laravel.talent_questions.race_options).includes(props.race)) {
            props.race_option = undefined;
        }

        if(!TB.isDefined(props.has_spoken_with_wripple)) {
            props.has_spoken_with_wripple = !!props.spoke_with_employee_named?.length
        }

        if(props.work_schedule_weeks) {

            let defaultHours = props.is_available ? props.available_hours_per_week : 0;

            let weekStep = TB.moment()
                .startOf('isoWeek')
                .utcOffset("+00:00", true);

            // Set 12 months of defaults if they are not already set
            let lastScheduledMonth = TB.moment()
                .subtract(1, 'month')
                .add(16, 'weeks')
                .endOf('month')
                .startOf('isoWeek')
                .utcOffset("+00:00", true);


            if (Object.keys(props.work_schedule_weeks).length < lastScheduledMonth.diff(weekStep, 'weeks')) {
                while (weekStep.isSameOrBefore(lastScheduledMonth)) {

                    let workScheduleStep = weekStep.format("YYYY-MM-DDTHH:mm:ssZ");

                    if (!TB.isDefined(props.work_schedule_weeks[workScheduleStep])) {
                        props.work_schedule_weeks[workScheduleStep] = defaultHours;
                    }
                    weekStep = weekStep.add(1, 'week');
                }
            }
        }

        if (!props.interview || !(props.interview instanceof Interview)) {

            let interviewProps = TB.pick(props,Interview.interviewProps);

            props.interview = Interview.make({
                ...(props.interview || {}),
                ...interviewProps
            });
        }
        if (props.talent_video_interview_steps) {
            props.talent_video_interview_steps = TB.orderBy(props.talent_video_interview_steps, 'id', 'desc');
            props.talent_video_interview_steps = TB.uniqBy(props.talent_video_interview_steps, 'step.id');
        }
        if (props.key_clients) {
            props.key_clients = TB.orderBy(props.key_clients, [client => !!client.display_index,'display_index'], ['desc', 'asc']);
            props.key_clients = TB.map(props.key_clients, client => {
                let formattedClient = TB.cloneDeep(client);
                if (formattedClient.assets?.length) {
                    const imageContentTypes = ['Image', 'Video'];
                    let assets = TB.map(TB.filter([...formattedClient.assets], asset => !!asset), asset => {
                        let formattedAsset = TB.cloneDeep(asset);
                        if (!formattedAsset.name) {
                            formattedAsset.name = asset.caption || (asset.path?.includes('http') ? `${asset.content_type} - ${client.headline}` : asset.path);
                        }
                        if (!formattedAsset.status) {
                            formattedAsset.status = 'done';
                        }

                        if (!formattedAsset.url && !(formattedAsset.path instanceof File)) {
                            formattedAsset.url = asset.path;
                        }

                        return formattedAsset;
                    })
                    formattedClient.assets = assets;

                    let [imgAssets, docAssets] = TB.partition(assets, asset => imageContentTypes.includes(asset.content_type))
                    formattedClient.imgAssets = TB.orderBy(imgAssets, ['display_index', 'desc'])
                    formattedClient.docAssets = TB.orderBy(docAssets, ['display_index', 'desc'])
                }
                return formattedClient;
            })
        }

        if (props.portfolio_url && !TB.isDefined(props.portfolio_url_has_notes)) {
            props.portfolio_url_has_notes = !!props.portfolio_url_notes;
        }
        if (props.profile_documents && props.profile_documents.length) {
            props.profile_documents = TB.orderBy(TB.map(props.profile_documents, doc => {
                if (!doc.uuid && doc.id) {
                    return {
                        ...doc,
                        uuid: doc.id,
                        type_id: doc.type,
                        type: doc.extension,
                        url: doc.path
                    }
                }
                return doc;
            }), 'display_index', 'asc');
        }
        // if (TB.isObject(props.resume_path)) {
        //     props.resume_path = Document.make(props.resume_path);
        // }
        // if (TB.isObject(props.linkedin_resume_path)) {
        //     props.linkedin_resume_path = Document.make(props.linkedin_resume_path);
        // }
        return props
	}

	static parsePhoneNumber(phoneNumberString) {
		let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
		let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
		if (match) {
			return [match[2], match[3], match[4]];
		}
		return null
	}


	static formatPhoneNumber(phoneNumberString) {
		let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
		let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
		if (match) {
			return ['(', match[2], ') ', match[3], '-', match[4]].join('')
		}

		return null
	}

	phoneNumber() {
	    return this.phone && User.formatPhoneNumber(this.phone)
    }

	fullName()
	{
		return `${this.first_name} ${this.last_name}`;
	}

	firstNamePlusInitial()
	{
		return `${this.first_name} ${this.last_name?.substr(0,1)}.`;
	}

    fullJobTitle()
    {
        if (!this.isTalent()) {
            return null
        }
        let title = this.job_title;
        if (!title && TB.isObject(this.supplier_client)) {
            title = "Talent Resource"
        }
        if (!title) return null


        return (
            <span>
                {title}
            </span>
        );
    }

	isRegistered()
	{
		return TB.isString(this.registered_at);
	}

	isDeactivated()
	{
		return TB.isString(this.deleted_at);
	}

    managerInterview() {
        if (this.interview && !(this.interview instanceof Interview)) {

            let interviewProps = TB.pick({...this},Interview.interviewProps);
            this.interview = Interview.make({

                ...this.interview,
                ...interviewProps
            });
        }

        return this.interview
    }

    static async submitInterview(talentId, props) {

        let user = Auth.registeredTalentUser();

        if (!user || !user.canManageTalent()) {
            return;
        }

        if (!props.interview) {
            props.interview = {}
        }

        props.interview.interviewed_at = new Date();

        await this.cancelRequest('UpdateInterviewForTalentManagerRequest')
        // console.log(formattedParams);
        this.UpdateInterviewForTalentManagerRequest = TB.request(
            TB.api_endpoint(`/api/users/talent/${talentId}/update`),
            props
        );


        let response = await this.UpdateInterviewForTalentManagerRequest.post()
            .catch(console.warn);

        if (!TB.has(response, 'success.data.user')) {
            return;
        }

        let updatedTalent = this.make({...response.success.data.user});

        TB.event("Talent@TalentVettingUpdate", updatedTalent)
        return updatedTalent;
	}


    static async updateTalentFromManager(talentId, props) {
        let user = Auth.registeredTalentUser();

        if (!user || !user.canManageTalent()) {
            return;
        }

        this.UpdateTalentForTalentManagerRequest = TB.request(
            TB.api_endpoint(`/api/users/talent/${talentId}/update`),
            props,
        );

        let response = await this.UpdateTalentForTalentManagerRequest.post()
            .catch(console.warn);

        if (!TB.has(response, 'success.data.user')) {
            return;
        }

        let updatedTalent = this.make({...response.success.data.user});

        TB.event("Talent@TalentVettingUpdate", updatedTalent)
        return updatedTalent;
	}

    /*
    |--------------------------------------------------------------------------
    | Network Requests
    |--------------------------------------------------------------------------
    */

    static FetchClientDashboardFeedRequest;

	static async fetchTalent(userId, params = {}, requestOptions = {})
	{

		this.FetchTalentRequest = TB.request(
			TB.api_endpoint(`/api/users/talent/${userId}`),params
		);

		let response = await this.FetchTalentRequest.get(requestOptions)
            .catch(console.warn);


        if (!response || !TB.has(response, 'success.data.user')) {
            return;
        }

		return this.make(
			response.success.data.user
		);
	}

    static talentStatusFlatLookup()
    {
        let lookup = laravel.talent_user_statuses;
        let statuses = []
        for (let [value,label] of Object.entries(lookup)) {
            if (label === 'Profile Under Review') {
                statuses.push({label: 'Profile Approval Requested', value: 'Profile Under Review'})
            }else {
                statuses.push({label, value: label})
            }
        }
        statuses.push(
            {label: 'Has Profile Appeal Pending Approval', value: 'Has Profile Appeal Pending Approval'},
            {label: 'Has Roles Pending Approval', value: 'Has Disciplines Pending Approval'},
            {label: 'Has Roles Appeals Pending Approval', value: 'Has Discipline Appeals Pending Approval'},
        )
        return statuses;
    }

    static colorForStatus(status) {
        if (status.includes(UserStatuses.Disabled) ||
            status.includes(UserStatuses.Deactivated) ||
            status.includes(UserStatuses.Restricted)) {
            return TB.config('color.danger-dark');
        }
	    if (status.match(/\((.*?)\)/) && status.match(/\((.*?)\)/).length > 0) {
	        status = status.match(/\((.*?)\)/)[0]
        }

        switch (status) {
            case UserStatuses.Unregistered:
                return TB.config('color.gray');

            case UserStatuses.ApprovedPendingAgreement:
            case UserStatuses.Applying:
            case UserStatuses.ActiveProfilePending:
            case UserStatuses.ActiveProfileIncomplete:
                return TB.config('color.blue');
            case UserStatuses.HasProfileAppealPendingApproval:
            case UserStatuses.BuildingProfile:
            case UserStatuses.ProfileUnderReview:
            case UserStatuses.PendingApproval:
            case UserStatuses.ApplicationUnderReview:
                return TB.config('color.warning-dark');
            case UserStatuses.ProfileRejected:
            case UserStatuses.RejectedApplication:
                return TB.config('color.danger-dark');
            case UserStatuses.HasDisciplinesPendingApproval:
            case UserStatuses.HasDisciplineAppealsPendingApproval:
            case UserStatuses.Active:
             return TB.config('color.light_purple');
            // case UserStatuses.Archived:
            case UserStatuses.Deactivated:
            case UserStatuses.Disabled:
            case UserStatuses.Restricted:
                return TB.config('color.black');
        }
    }
    static labelForStatus(status) {

        if (status.includes(UserStatuses.Disabled)) {
            return 'Disabled'
        }
        if (status.includes(UserStatuses.Deactivated)) {
            return 'Deactivated'
        }
        if (status.includes(UserStatuses.Restricted)) {
            return 'Restricted'
        }
        if (status.match(/\((.*?)\)/) && status.match(/\((.*?)\)/).length > 0) {
            status = status.match(/\((.*?)\)/)[0]
        }


        switch (status) {
            case UserStatuses.Unregistered:
                return 'Unregistered';
            case UserStatuses.ApprovedPendingAgreement:
            case UserStatuses.ActiveProfilePending:
            case UserStatuses.Applying:
            case UserStatuses.ActiveProfileIncomplete:
                return 'Registered';
            case UserStatuses.HasProfileAppealPendingApproval:
            case UserStatuses.BuildingProfile:
            case UserStatuses.ProfileUnderReview:
            case UserStatuses.PendingApproval:
            case UserStatuses.ApplicationUnderReview:
                return 'Pending'
            case UserStatuses.ProfileRejected:
            case UserStatuses.RejectedApplication:
                return status;
            case UserStatuses.Disabled:
            case UserStatuses.Deactivated:
            case UserStatuses.Restricted:
                return 'Inactive'
            case UserStatuses.Active:
                return 'Active'
            // case UserStatuses.Archived:
        }
    }

    canViewClientProfile() {
	    let status = this.status;
        if (status.match(/\((.*?)\)/) && status.match(/\((.*?)\)/).length > 0) {
            status = status.match(/\((.*?)\)/)[0]
        }

        let activeStatuses = [
            UserStatuses.Applying,
            UserStatuses.PendingApproval,
            UserStatuses.BuildingProfile,
            UserStatuses.ProfileUnderReview,
            UserStatuses.HasProfileAppealPendingApproval,
            UserStatuses.ProfileRejected,
            UserStatuses.ApprovedPendingAgreement,
            UserStatuses.ActiveProfileIncomplete,
            UserStatuses.ActiveProfilePending,
            UserStatuses.Active
        ];

	    return activeStatuses.includes(status)
    }

    profileApprovalStatus() {
        if (!this.isApplicationApproved()) {
            return 'Pending Application Approval'
        }

        if (this.latest_appeal) {
            if (this.latest_appeal.is_rejected) {
                return 'Profile Appeal Rejected'
            }
            if (this.latest_appeal.is_approved) {
                return 'Profile Appeal Approved'
            }
            return 'Profile Appeal Requested!';
        }

        if (this.talent_profile_rejected_at) {
            return 'Profile Rejected';
        }

        if (this.status === UserStatuses.BuildingProfile) {
            return 'Building Profile'
        }

        if (this.talent_profile_approved_at) {
            return 'Profile Approved';
        }

        if (this.talent_profile_review_requested_at) {
            return 'Profile Approval Requested';
        }

    }
    profileApprovalStatusColor() {
        if (!this.isApplicationApproved()) {
            return '#797979'
        }
        if (this.status === UserStatuses.BuildingProfile) {
            return TB.config('color.info-dark')
        }
        if (this.talent_profile_rejected_at) {
            if (this.latest_appeal) {
                if (this.latest_appeal.rejected_at) {
                    return TB.config('color.danger-dark')
                }
                if (this.latest_appeal.approved_at) {
                    return TB.config('color.success-darker')
                }
                return TB.config('color.warning-dark');
            }

            return TB.config('color.danger-dark');
        }

        if (this.talent_profile_approved_at) {
            return TB.config('color.success-darker');
        }

        if (this.talent_profile_review_requested_at) {
            return TB.config('color.warning-dark');
        }
    }

    /*
    |--------------------------------------------------------------------------
    | Cache
    |--------------------------------------------------------------------------
    */

    static refreshCacheFor(user)
    {
    	if (!this.Cached) {
    		return;
    	}

    	let updatedUser = this.make({...user}),
    		didUpdate = false;

		for (let i in this.Cached) {
			if (this.Cached[i].id == user.id) {
				this.Cached[i] = updatedUser;
				didUpdate = true;
				break;
			}
		}

		if (!didUpdate) {
			this.Cached.push(updatedUser);
		}

		TB.event('Users@updated');

		return updatedUser;
    }

    static clearCache()
    {
    	this.Cached = undefined;
    }

    /*
    |--------------------------------------------------------------------------
    | System Admin/User Helper Methods
    |--------------------------------------------------------------------------
    */

    isAuthUser()
    {
        return TB.auth().user()?.id === this.id;
    }

    canManageClients()
    {
        return this.isClientConsultant() || this.isClientManager() || this.isPlatformUser();
    }

    canManageTalent()
    {
        return this.isClientConsultant() || this.isTalentManager() || this.isPlatformUser();
    }

    isPlatformUser()
	{
		return this.isSystemUser()
			|| this.isSystemAdmin()
			|| this.isSystemDev();
	}

	isSystemUser()
	{
		return this.type === laravel.user_types.system_user;
	}

	isSystemAdmin()
	{
		return this.type === laravel.user_types.system_admin;
	}

	isSystemDev()
	{
		return this.type === laravel.user_types.dev;
	}

    isClientOrTalentUser()
    {
        return this.type === laravel.user_types.client || this.type === laravel.user_types.talent;
    }

    talentPortalType() {
        if (this.canManageClientResourceTalent()) {
            return 'supplier'
        }

        return 'talent';
    }

    /*
    |--------------------------------------------------------------------------
    | Notification Settings
    |--------------------------------------------------------------------------
    */
    static GetUserPreferencesRequest;
	async getNotificationSettings() {
	    if (!this.isAuthUser()) {
	        return false;
        }

	    if (User.GetUserPreferencesRequest?.isRunning()) {
            await this.constructor.cancelRequest('GetUserPreferencesRequest');
        }

	    this.constructor.GetUserPreferencesRequest = TB.request(
            TB.api_endpoint(`/api/notification-settings`)
        )

	    let response = await this.constructor.GetUserPreferencesRequest.get().catch(console.warn);

	    if (!response || !TB.has(response, 'success.data.notification_settings')) {
	        return false;
        }

	    let categories = TB.orderBy([...response.success.data.notification_settings], 'display_index', 'asc');

        categories = TB.map(categories, category => {
	        category.settings = TB.orderBy(category.settings || [], 'display_index', 'asc');
	        return category;
        })

        this.settings = await this.settingsFormModel(categories);

        TB.auth().User = this.constructor.make({...this});

	    return categories
    };

	async settingsFormModel(userSettings) {


	    let model = TB.reduce((userSettings || []), (settings, tab) => {

            TB.map((tab.groups || []), group => {
    	        TB.map((group.settings || []), setting => {
                    TB.map(setting.options || [], optionSetting => {
                        settings[optionSetting.settings_prop] = !!optionSetting.settings_value;
                    })
                })
            })

            return settings
        }, {})

        return model
    }


	/*
    |--------------------------------------------------------------------------
    | Team User Helper Methods
    |--------------------------------------------------------------------------
    */
    skillsById()
    {
    	if (!this.skills) {
    		return [];
    	}

    	return TB.pluck(
    		TB.sortBy(
    			TB.values(this.skills), 'self_score'
    		),
            'id'
		);
    }

    rankedSkills()
    {
    	if (!this.skills) {
    		return [];
    	}

    	return TB.reverse(
    		TB.sortBy(
    			TB.values(this.skills), 'self_score'
    		)
		);
    }

  //   rankedSkillsThatMatch(importantSkills)
  //   {
  //   	let skillsLookup = TB.keyBy(importantSkills, 'id');
  //   	let rankedSkills = this.rankedSkills();

  //   	for (let skill of rankedSkills) {
  //   		if (!skillsLookup[skill.id]) {
  //   			continue;
  //   		}
  //   		skillsLookup[skill.id].self_score = skill.self_score;
  //   		skillsLookup[skill.id].factor = skill.self_score * skillsLookup[skill.id].importance;
  //   	}

  //   	return TB.reverse(
  //   		TB.sortBy(
  //   			TB.values(skillsLookup), 'factor'
  //   		)
		// );
  //   }

    experiencedIndustries()
    {
    	if (!this.industries_worked) {
    		return [];
    	}

    	return TB.reverse(
    		TB.sortBy(
    			TB.values(this.industries_worked), 'talent_score'
    		)
		);
    }

    experiencedIndustriesById()
    {
        if (!this.industries_worked) {
            return [];
        }

        return TB.pluck(
            TB.sortBy(
                TB.values(this.industries_worked), 'self_score'
            ),
            'id'
        );
    }

    industryExperienceForProject(project)
    {
    	if (!project || !project.client || !project.client.industry) {
    		return;
    	}

    	let industry = TB.keyBy(
    		this.industries_worked, 'id'
    	)[project.client.industry.id];

    	if (!industry) {
    		return;
    	}

    	return industry.years_of_experience;
    }

    /*
    |--------------------------------------------------------------------------
    | Project Assignments
    |--------------------------------------------------------------------------
    */
    assignedProjects()
    {
    	if (!this.assigned_projects || !TB.isArray(this.assigned_projects)) {
    		return [];
    	}

    	return Project.makeMany(
    		this.assigned_projects
    	);
    }

    isAssignedToProject(project)
    {
    	if (!this.assigned_projects || !TB.isArray(this.assigned_projects)) {
    		return false;
    	}

    	let assignedProject = TB.keyBy(this.assigned_projects, 'id')[project.id];

    	return TB.isObject(assignedProject);
    }

    /*
    |--------------------------------------------------------------------------
    | Match Helper Methods
    |--------------------------------------------------------------------------
    */
    matchedDisciplines(disciplines) {
        let profileDisciplines = TB.keyBy(this.talent_disciplines || [], 'id');

        let profileDisciplineIds = TB.map(this.talent_disciplines || [], 'id');

        let matchedDisciplines = TB.filter(
            disciplines,
            discipline => profileDisciplineIds.includes(discipline.id)
        );

        if (!matchedDisciplines.length) return [];

        matchedDisciplines = TB.map(matchedDisciplines, discipline => (
            {
            ...discipline,
            ...(profileDisciplines[discipline.id])}
        ));
        return TB.orderBy(matchedDisciplines, ['self_score', 'desc'])
    }

    selectedSkillsForDiscipline(discipline_id) {
        if (!this.isTalent() || !discipline_id) {
            return [];
        }
        let skills = Discipline.skillsFor(discipline_id);

        let userSkillIds = TB.map(this.skills, 'id');

        return TB.filter(skills, skill => userSkillIds?.includes(skill.id));
    }

    static ExperienceLevels() {
        return TB.map(laravel.talent_experience_levels, (level, value) => {
            let sliderValue = 0;
            switch (parseInt(value)) {
                case 1:
                    sliderValue = 1;
                    break;
                case 2:
                    sliderValue = 26;
                    break;
                case 3:
                    sliderValue = 51;
                    break;
                case 4:
                    sliderValue = 76;
                    break;
            }

            return {
                sliderValue,
                ...level,
                value
            }

        })
    }
}

const transformForUpdate = (params) => {

    let talentDisciplinesParams = ['id', 'self_score', 'hourly_rate']
    let talentSkillsParams = ['id', 'self_score']

    let updatedParams = {};
    for (let [key, value] of Object.entries(params)) {
        switch (key) {
            default:
                updatedParams[key] = value;
                break;
            case 'talent_disciplines':
                updatedParams[key] = TB.map(value || [], discipline => {
                    if (!discipline) return discipline;

                    return TB.pick(discipline, talentDisciplinesParams);
                })
                break;

            case 'skills':
                updatedParams[key] = TB.map(value || [], skill => {
                    if (!skill) return skill

                    return TB.pick(skill, talentSkillsParams);
                })
                break;
        }
    }
    return updatedParams;
}

const talentUpdateRequest = async (params, requestEndpoint) => {


    let transformedParams = transformForUpdate({ ...params });

    TB.auth().TalentUpdateRequest = TB.request(
        TB.api_endpoint(requestEndpoint), transformedParams
    );
    const checkForFile = (props) => {

        if (typeof props !== 'object' && !Array.isArray(props)) {
            return false;
        }
        return TB.filter(TB.values(props), value => {
            if (value instanceof File) return true;
            if (typeof value === 'object' || Array.isArray(value)) {
                return checkForFile(value);
            }
            return false;
        }).length > 0
    }
    if (checkForFile(transformedParams)) {
        console.log('File found!')
        TB.auth().TalentUpdateRequest = TB.auth().TalentUpdateRequest.headers({
            'Content-Type': 'multipart/form-data'
        })
    }

    let response = await TB.auth().TalentUpdateRequest.post().catch(e => {
        console.warn('ERROR: talentUpdate', e);

    })

    if (!response || !(TB.has(response, 'success.data.auth') || TB.has(response, 'success.data.user'))) {
        TB.auth().TalentUpdateRequest.didHandleError = await TB.auth().TalentUpdateRequest.handleError();
        if (TB.auth().TalentUpdateRequest.didHandleError
            && TB.auth().TalentUpdateRequest.shouldRerun) {
            return talentUpdateRequest(params);
        }

        return false;
    }

    return User.make({ ...(response.success.data.auth || response.success.data.user) })
}

export {
    talentUpdateRequest,
}